import React, { useEffect } from "react";
import "./onboardscreens.css";
import OnboardingRoute from "../../routes/OnboardingRoute";
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

function Onboardscreens() {
  const history = useHistory();
  const userLogin = useSelector(state => state.userLogin);
  const { userInfo } = userLogin;

  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    }
  }, [userInfo, history])

  return (
    <div className="onboardscreens">
      <div className="onboardscreens__container">
        <OnboardingRoute />
      </div>
    </div>
  );
}
export default Onboardscreens;
